import React from 'react';

export const QuantitySelector = ({ title, amount, decrease, increase }) => {
  return (
    <div className="grid grid-cols-12 gap-2 text-sm font-semibold text-gray-600 mb-2 mt-4 px-1">
      <span className="col-span-3">{title}</span>
      <div className="col-span-9 flex items-center gap-2">
        <button
          type="button"
          onClick={decrease}
          className="px-2 border rounded text-sm"
        >
          −
        </button>
        <span>{amount}</span>
        <button
          type="button"
          onClick={increase}
          className="px-2 border rounded text-sm"
        >
          +
        </button>
      </div>
    </div>
  );
};
